// Single shared data source for approved Articles.
// All Article-gallery cards and Article detail pages read from this file.
// Do not duplicate this data in another file. Do not seed sample Articles.
// Content is verbatim from Dr Tania Gurdip Singh's approved brief.

export const APPROVED_ARTICLES = [
  {
    slug: "deranged-doppler-fetal-growth-restriction",
    testid: "article-deranged-doppler-fetal-growth-restriction",
    category: "Fetal Medicine",
    title: "Deranged Doppler in Fetal Growth Restriction: What Happens Next?",
    seoTitle:
      "Deranged Doppler in Fetal Growth Restriction: What Happens Next? | Dr Tania Gurdip Singh",
    metaDescription:
      "A clear explanation of abnormal umbilical artery, middle cerebral artery and ductus venosus Doppler findings in fetal growth restriction—and how they affect surveillance and timing of birth.",
    cardDescription:
      "A clear explanation of abnormal umbilical artery, middle cerebral artery and ductus venosus Doppler findings in fetal growth restriction—and how they affect surveillance and timing of birth.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Fetal Growth Restriction",
  },
  {
    slug: "hyperthyroidism-pregnancy-fetal-thyroid",
    testid: "article-hyperthyroidism-pregnancy-fetal-thyroid",
    category: "Medical Disorders in Pregnancy",
    title:
      "Hyperthyroidism in Pregnancy: Can My Baby’s Thyroid Be Affected Even When My Tests Are Normal?",
    seoTitle:
      "Hyperthyroidism in Pregnancy and the Baby’s Thyroid | Dr Tania Gurdip Singh",
    metaDescription:
      "Why Graves’ antibodies can affect the fetal thyroid even after normal maternal thyroid tests, surgery or radioiodine—and what monitoring the baby may need.",
    cardDescription:
      "Why Graves’ antibodies can affect the fetal thyroid even after normal maternal thyroid tests, surgery or radioiodine—and what monitoring the baby may need.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Hyperthyroidism in Pregnancy",
  },
  {
    slug: "gallstones-pregnancy-surgery",
    testid: "article-gallstones-pregnancy-surgery",
    category: "Surgical Disorders in Pregnancy",
    title: "Gallstones in Pregnancy: When Is Surgery Safer Than Waiting?",
    seoTitle:
      "Gallstones in Pregnancy: When Is Surgery Safer Than Waiting? | Dr Tania Gurdip Singh",
    metaDescription:
      "A clear guide to gallstone pain, cholecystitis, pancreatitis, ERCP and laparoscopic gallbladder surgery during pregnancy—and when delaying treatment may be riskier.",
    cardDescription:
      "A clear guide to gallstone pain, cholecystitis, pancreatitis, ERCP and laparoscopic gallbladder surgery during pregnancy—and when delaying treatment may be riskier.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Gallstones in Pregnancy",
  },
  {
    slug: "chronic-kidney-disease-pregnancy-preeclampsia",
    testid: "article-chronic-kidney-disease-pregnancy-preeclampsia",
    category: "Medical Disorders in Pregnancy",
    title:
      "Chronic Kidney Disease in Pregnancy: Is It Kidney Disease—or Preeclampsia?",
    seoTitle:
      "Chronic Kidney Disease in Pregnancy: CKD or Preeclampsia? | Dr Tania Gurdip Singh",
    metaDescription:
      "How creatinine, proteinuria, blood pressure, placental biomarkers and fetal growth help distinguish chronic kidney disease from superimposed preeclampsia in pregnancy.",
    cardDescription:
      "How creatinine, proteinuria, blood pressure, placental biomarkers and fetal growth help distinguish chronic kidney disease from superimposed preeclampsia in pregnancy.",
    readingTimeMinutes: 6,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Chronic Kidney Disease in Pregnancy",
  },
  {
    slug: "torch-igg-igm-positive-pregnancy",
    testid: "article-torch-igg-igm-positive-pregnancy",
    category: "Infections in Pregnancy",
    title:
      "TORCH Tests in Pregnancy: Does IgG Positive Mean My Baby Is Infected?",
    seoTitle:
      "TORCH IgG and IgM Positive in Pregnancy: What Do They Mean? | Dr Tania Gurdip Singh",
    metaDescription:
      "What IgG positive and IgM positive mean in pregnancy—and why Rubella, CMV, Toxoplasma and Herpes results must not be interpreted in the same way.",
    cardDescription:
      "What IgG positive and IgM positive mean in pregnancy—and why Rubella, CMV, Toxoplasma and Herpes results must not be interpreted in the same way.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "TORCH Infections in Pregnancy",
  },
  {
    slug: "psoriasis-pregnancy-treatment-biologics",
    testid: "article-psoriasis-pregnancy-treatment-biologics",
    category: "Medical Disorders in Pregnancy",
    title:
      "Psoriasis in Pregnancy: Is the Disease More Dangerous—or the Treatment?",
    seoTitle: "Psoriasis in Pregnancy: Safe Treatment and Biologics | Dr Tania Gurdip Singh",
    metaDescription:
      "Which psoriasis treatments are safer in pregnancy, which must be avoided, how biologics affect the baby’s live vaccines, and when a flare needs urgent care.",
    cardDescription:
      "Which psoriasis treatments are safer in pregnancy, which must be avoided, how biologics affect the baby’s live vaccines, and when a flare needs urgent care.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Psoriasis in Pregnancy",
  },
  {
    slug: "epilepsy-pregnancy-seizure-medicine",
    testid: "article-epilepsy-pregnancy-seizure-medicine",
    category: "Medical Disorders in Pregnancy",
    title:
      "Epilepsy in Pregnancy: Is the Medicine More Dangerous—or the Seizure?",
    seoTitle:
      "Epilepsy in Pregnancy: Seizures, Medicines and Monitoring | Dr Tania Gurdip Singh",
    metaDescription:
      "Why epilepsy medicines must not be stopped suddenly, how pregnancy changes drug levels, which treatments need special caution, and what to plan for birth.",
    cardDescription:
      "Why epilepsy medicines must not be stopped suddenly, how pregnancy changes drug levels, which treatments need special caution, and what to plan for birth.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Epilepsy in Pregnancy",
  },
  {
    slug: "oral-thrush-pregnancy-candidiasis",
    testid: "article-oral-thrush-pregnancy-candidiasis",
    category: "Medical Disorders in Pregnancy",
    title:
      "Oral Thrush in Pregnancy: Is It Harmful to the Baby—or a Sign Something Else Needs Checking?",
    seoTitle:
      "Oral Thrush in Pregnancy: Causes, Treatment and Warning Signs | Dr Tania Gurdip Singh",
    metaDescription:
      "Why oral thrush usually does not harm the baby, which treatments may be used in pregnancy, and when recurrent infection needs further testing.",
    cardDescription:
      "Why oral thrush usually does not harm the baby, which treatments may be used in pregnancy, and when recurrent infection needs further testing.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Oral Thrush in Pregnancy",
  },
  {
    slug: "hepatitis-b-positive-partner-pregnancy",
    testid: "article-hepatitis-b-positive-partner-pregnancy",
    category: "Medical Disorders in Pregnancy",
    title:
      "Hepatitis B–Positive Partner in Pregnancy: Can His High Viral Load Affect Me or My Baby?",
    seoTitle:
      "Hepatitis B–Positive Partner in Pregnancy: Testing and Baby Risk | Dr Tania Gurdip Singh",
    metaDescription:
      "Why a partner’s high hepatitis B viral load does not directly infect the baby, which tests the mother needs, and when vaccination or HBIG is urgent.",
    cardDescription:
      "Why a partner’s high hepatitis B viral load does not directly infect the baby, which tests the mother needs, and when vaccination or HBIG is urgent.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Hepatitis B in Pregnancy",
  },
  {
    slug: "obesity-pregnancy-heparin-injections",
    testid: "article-obesity-pregnancy-heparin-injections",
    category: "Medical Disorders in Pregnancy",
    title: "Obesity in Pregnancy: Does Every Woman Need Heparin Injections?",
    seoTitle:
      "Obesity in Pregnancy: When Are Heparin Injections Needed? | Dr Tania Gurdip Singh",
    metaDescription:
      "Why obesity does not automatically mean heparin throughout pregnancy, how clot risk changes after admission or birth, and why dose and timing need a plan.",
    cardDescription:
      "Why obesity does not automatically mean heparin throughout pregnancy, how clot risk changes after admission or birth, and why dose and timing need a plan.",
    readingTimeMinutes: 5,
    author: "Dr Tania Gurdip Singh",
    aboutCondition: "Obesity in Pregnancy",
  },
];
